"use client";

import { motion } from "motion/react";

import { TextRoll } from "@/components/motion/text-roll";
import { Link } from "@/i18n/navigation";

// =============================================================================

type FooterLinkProps = {
  href: string;
  children: string;
};

/**
 * Footer navigation link: letters roll on hover, a line underlines it.
 */
export function FooterLink({ href, children }: FooterLinkProps) {
  return (
    <motion.span
      initial="rest"
      whileHover="hover"
      animate="rest"
      className="inline-block"
    >
      <Link
        href={href}
        className="group relative inline-block text-lg text-muted-foreground transition-colors duration-500 hover:text-foreground"
      >
        <TextRoll>{children}</TextRoll>
        <span
          aria-hidden
          className="absolute -bottom-0.5 left-0 h-px w-full origin-right scale-x-0 bg-current transition-transform duration-500 ease-(--ease-out-expo) group-hover:origin-left group-hover:scale-x-100"
        />
      </Link>
    </motion.span>
  );
}

// =============================================================================
